import { BaseHttpResponseError } from './base-http.error';

export class ItemNotFoundInDatabaseError extends BaseHttpResponseError {
  constructor(err) {
    super(err);
  }
}

export class RecordNotFoundInEDPDatabaseError extends BaseHttpResponseError {
  constructor(err) {
    super(err);
  }
}

export class UnauthorizedGeoPermissionsError extends BaseHttpResponseError {
  constructor(err) {
    super(err);
  }
}
